import { focusToBackgroundStyle, IImage } from "@eventr/common";
import { AuthImage } from "@eventr/common-storybook";
import { Box } from "@mui/material";

interface IActivityImageProps {
  images: IImage[];
  isAdvance?: boolean;
}

export const ActivityImage = ({ images, isAdvance }: IActivityImageProps) => {
  if (!isAdvance) return null;
  const image = images[0];
  if (!image?.url) return null;
  return (
    // The negative margin positions the outer element, and a zoom needs something to clip
    // against, so both live on the wrapper.
    <Box sx={{ margin: "-8px -8px 0px -8px", height: "77px", overflow: "hidden" }}>
      {/* AuthImage in Box mode paints a `background-image`. Inline `style` beats its own
          emotion `sx` defaults, which is what lets the framing win - so do not move it. */}
      <AuthImage height="77px" style={focusToBackgroundStyle(image.focus)} src={image.url} />
    </Box>
  );
};
